import cn from 'classnames';

import { VideoWithContent as VideoWithContentInterface } from '@interfaces';
import { ButtonProps } from '@components/Button';
import { Content } from '@components/Content';
import { LinkProps } from '@components/Link';
import { useTheme } from '@utilities';
import { Theme } from '@contexts';

import classes from './VideoWithContent.classes';

export interface VideoWithContentProps extends VideoWithContentInterface {}

function VideoWithContent({
  button,
  caption,
  captionImage,
  link,
  richText,
  blockTheme,
  blockIdentifier,
  title,
  videoPositionMobile,
  videoPositionDesktop,
  video,
  customID,
}: VideoWithContentProps): JSX.Element {
  const theme = useTheme({ blockTheme });

  const contentContainerClasses = [
    classes.contentContainer,
    videoPositionMobile === 'top' ? classes.contentContainerVideoTop : classes.contentContainerVideoBottom,
    videoPositionDesktop === 'left' ? classes.contentContainerVideoLeft : classes.contentContainerVideoRight,
  ];

  let buttonProps: ButtonProps | undefined;

  if (button) {
    buttonProps = {
      ...button,
      elementClick: `button[${button.name}]_${blockIdentifier}`,
      children: button.name,
    };
  }

  let linkProps: LinkProps | undefined;

  if (link) {
    linkProps = {
      ...link,
      icon: 'fas fa-arrow-right',
      elementClick: `link[${link.name}]_${blockIdentifier}`,
      children: link.name,
    };
  }

  return (
    <Theme.Provider value={theme}>
      <div className={classes.videoWithContent} id={customID}>
        <Content
          className={cn(contentContainerClasses)}
          caption={caption}
          captionImage={captionImage}
          title={title}
          richText={richText}
          buttonProps={buttonProps}
          linkProps={linkProps}
        />
        <div className={classes.videoContainer}>
          <iframe className={classes.video} src={video.src} title={`${video.provider} video player`} />
        </div>
      </div>
    </Theme.Provider>
  );
}

export default VideoWithContent;
